import { render } from "./AdviserHubLayout.vue?vue&type=template&id=4734d180&scoped=true&ts=true"
import script from "./AdviserHubLayout.vue?vue&type=script&lang=ts"
export * from "./AdviserHubLayout.vue?vue&type=script&lang=ts"

import "./AdviserHubLayout.vue?vue&type=style&index=0&id=4734d180&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4734d180"]])

export default __exports__